import 'core-js/stable';

// TEMPLATE CSS
import '../template/css/bootstrap.min.css';
import '../template/css/bootstrap-extend.min.css';
import '../template/css/site.css';
import '../template/skins/blue.css';

// JS
import Rails from '@rails/ujs';
import * as toastr from 'toastr';
import FlashToastr from '../application/FlashToastr';

global.$ = require('jquery');
window.toastr = toastr
toastr.options.preventDuplicates = true;
toastr.options.positionClass = 'toast-top-full-width';
toastr.options.closeButton = true
toastr.escapeHtml = true;

$(document).ready(() => {
  Rails.start();
  FlashToastr.display();
});
